module.exports = __webpack_public_path__ + "static/img/yy18.619b5c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy18.png
// module id = yit9
// module chunks = 1